import { Button, Form, FormProps, Input } from 'antd';
import React from 'react';
import { getExcessivePaidForm } from './actions';
import { filterDigits, localize } from '/react4xp/mixins/helpers';

type FirstStepFormProps = {
    translations: Record<string, string>;
    onSuccess: (data: { excessivePaidXML: string; taxpayerCode: string }) => void;
};

type Inputs = {
    taxpayerCode: string;
    taxOrgCode: string;
    kbk: string;
};

export const FirstStepForm = (props: FirstStepFormProps) => {
    const [form] = Form.useForm();

    const onFinish: FormProps<Inputs>['onFinish'] = async (values) => {
        const excessivePaidXML = await getExcessivePaidForm(values);
        props.onSuccess({ excessivePaidXML, taxpayerCode: values.taxpayerCode });
    };

    return (
        <Form
            layout={'vertical'}
            name={'excessive-paid-service-step-1'}
            onFinish={onFinish}
        >
            <Form.Item
                name={'taxpayerCode'}
                label={'ИИН'}
                rules={[
                    {
                        required: true,
                        message: localize('error.field-is-required', props.translations),
                    },
                    {
                        min: 12,
                        message: 'Поле ИИН должно состоять из 12 цифр',
                    },
                ]}
            >
                <Input
                    onChange={filterDigits(form, 'taxpayerCode')}
                    maxLength={12}
                    placeholder={localize('placeholder.input', props.translations)}
                />
            </Form.Item>

            <Form.Item
                name={'taxOrgCode'}
                label={'Код ОГД'}
                rules={[
                    {
                        required: true,
                        message: localize('error.field-is-required', props.translations),
                    },
                    {
                        min: 6,
                        message: 'Поле Код ОГД должно состоять из 6 цифр',
                    },
                ]}
            >
                <Input
                    onChange={filterDigits(form, 'kbk')}
                    maxLength={6}
                    placeholder={localize('placeholder.input', props.translations)}
                />
            </Form.Item>

            <Form.Item
                name={'kbk'}
                label={'КБК'}
                rules={[
                    {
                        required: true,
                        message: localize('error.field-is-required', props.translations),
                    },
                    {
                        min: 6,
                        message: 'Поле КБК должно состоять из 6 цифр',
                    },
                ]}
            >
                <Input
                    onChange={filterDigits(form, 'kbk')}
                    maxLength={6}
                    placeholder={localize('placeholder.input', props.translations)}
                />
            </Form.Item>

            <Button htmlType={'submit'}>{localize('button.send', props.translations)}</Button>
        </Form>
    );
};
